import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserContextService } from '../../shared/services/user-context.service';
import { ViewingContextService } from '../../shared/services/viewing-context.service';
import { ROUTES } from '../../shared/constants';

/**
 * Guard that prevents access to owner-only routes (Circle, Vault)
 * when the user is viewing another family as a non-admin member.
 */
export const ownerOnlyGuard: CanActivateFn = () => {
  const userContext = inject(UserContextService);
  const viewingContext = inject(ViewingContextService);
  const router = inject(Router);

  // Member-only users never have owner routes
  if (userContext.isCircleMemberOnly()) {
    return router.createUrlTree([ROUTES.HOME]);
  }

  // Dual user viewing another family as read-only member
  if (viewingContext.isViewingParent() && viewingContext.isReadOnly()) {
    return router.createUrlTree([ROUTES.HOME]);
  }

  return true;
};
